/**
 * Formatação em português do Brasil, sem travessão em nenhuma string de UI.
 * Valor vazio é "sem registro", nunca um traço solto.
 */
export const SEM_REGISTRO = "sem registro";

export const moeda = (v: string | number | null | undefined): string => {
  if (v === null || v === undefined || v === "") return SEM_REGISTRO;
  const n = typeof v === "number" ? v : Number(String(v).replace(",", "."));
  if (!Number.isFinite(n)) return SEM_REGISTRO;
  return n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
};

export const data = (iso: string | null | undefined): string => {
  if (!iso) return SEM_REGISTRO;
  const [a, m, d] = iso.slice(0, 10).split("-");
  return d && m && a ? `${d}/${m}/${a}` : SEM_REGISTRO;
};

export const competencia = (c: string | null | undefined): string => {
  if (!c) return SEM_REGISTRO;
  const [a, m] = c.split("-");
  const meses = ["janeiro", "fevereiro", "março", "abril", "maio", "junho",
    "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];
  const i = Number(m) - 1;
  return meses[i] ? `${meses[i]} de ${a}` : c;
};

/** Minutos viram "8h30", que é como o DP lê, e nunca 8,5. */
export const duracao = (minutos: number | null | undefined): string => {
  if (minutos === null || minutos === undefined) return SEM_REGISTRO;
  const sinal = minutos < 0 ? "-" : "";
  const abs = Math.abs(minutos);
  const h = Math.floor(abs / 60);
  const m = abs % 60;
  return `${sinal}${h}h${String(m).padStart(2, "0")}`;
};

export const cpf = (v: string | null | undefined): string => {
  const d = (v ?? "").replace(/\D/g, "");
  if (d.length !== 11) return v || SEM_REGISTRO;
  return `${d.slice(0, 3)}.${d.slice(3, 6)}.${d.slice(6, 9)}-${d.slice(9)}`;
};

export const plural = (n: number, um: string, muitos: string): string =>
  `${n} ${n === 1 ? um : muitos}`;

/** CNPJ com máscara. Aceita raiz de 8 dígitos, que é o que a empresa guarda. */
export const cnpj = (v: string | null | undefined): string => {
  const d = (v ?? "").replace(/\D/g, "");
  if (d.length === 8) return d.replace(/(\d{2})(\d{3})(\d{3})/, "$1.$2.$3");
  if (d.length !== 14) return v?.trim() || SEM_REGISTRO;
  return d.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5");
};
